export default (initialState = {}) => {
  return () => {
    return {
      _id: "",
      application_status: "",
      basicInfo: {
        business_channel: [],
        email: "",
        name: "",
        phone: "",
        role: "",
        shop_name: "",
        trade_name: "",
        is_internal_user: false,
        distribution_type: "wholesaler",
      },
      businessDetails: {
        address: "",
        city: "",
        state_cd: "",
        pincode: "",
        country: "",
        country_cd: "",
        directors: [
          {
            name: "",
            phone: "",
            pan: "",
            aadhar: "",
            date_of_birth: "",
            credit_score: null,
            is_primary: false,
          },
        ],
        fssai: "",
        udyam_aadhar: "",
        msme_category: "",
        gstin: null,
        is_gst_registered: true,
        shop_name: "",
        legal_business_name: "",
        business_type: null,
        registration_date: null,
        incorporation_date: null,
        number_of_director: 1,
        gstin_status: "",
        filing_frequency: "",
        latest_gst_filed: null,
        gst_filing_status_count: null,
        total_gross_income: null,
        annual_aggregate_turnover: "",
        aggregate_turnover_range: { minimum: null, maximum: null },
      },
      othersInfo: {
        account_owner: undefined,
        associated_agent: undefined,
        categories: [],
        products: [],
        demand_broadcast: false,
        poSetting: {
          po_applicable: false,
          po_file_applicable: false,
        },
      },
      bankInfo: {
        account_number: "",
        bank_beneficiary_name: "",
        ifsc_code: "",
        bank_name: "",
        code: "",
        is_primary: true,
        file: null,
        file_category: "",
        file_type: "",
        shop_name: "",
        document_id: "",
        file_id: "",
      },
      taxSettingsInfo: {
        tax_settings: {
          _id: null,
          code: "",
          percentage: 0,
          type: "",
          name: "",
          applicable: [],
          ...initialState,
        },
        min_net_sales_margin: 1,
      },
      paymentsTermsInfo: {
        credit_cycle: 7,
        credit_limit: 1,
        credit_eligibility: { name: "Eligible", code: "E", value: true },
      },
      creditSummary: {},
      ...initialState,
    };
  };
};
